import * as S from '#features/ScheduleRegistration/components/LectureRegistration/RowSearchMember/SearchLectureMember/SearchMemberForm/styles';
import Icon from '#shared/Icon';
import { ChangeEvent, useState } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputWrapperStyle?: React.CSSProperties;
  onReset?: () => void;
}

export const Input = ({
  inputWrapperStyle,
  onChange,
  onReset,
  ...props
}: InputProps) => {
  const [query, setQuery] = useState<string>();
  const [focused, setFocused] = useState<boolean>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
  };

  return (
    <S.InputWrapper style={inputWrapperStyle} focused={focused}>
      <S.Input
        value={query}
        onChange={e => {
          setQuery(e.target.value);
          handleChange(e);
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...props}
      />
      {props.value && onReset && (
        <div
          onClick={onReset}
          className="absolute right-5 top-1/2 transform -translate-y-1/2"
        >
          <Icon name="IconClose" width={16} height={16} />
        </div>
      )}
    </S.InputWrapper>
  );
};
